<template>
    <div class="wrapper">
        <ion-item v-if="currentOptions.length">
            <ion-label class="selector-label" position="floating">{{ label }}</ion-label>
            <ion-select ref="selector" okText="Okay" cancelText="Dismiss" @ionChange="handleChange" class="ion-selector">
                <div v-for="option in currentOptions" :key="option.id">
                    <ion-select-option v-if="option.value === currentValue" :value="option.id" :selected="true">{{
                        $t('options.' + option.value)
                    }}</ion-select-option>
                    <ion-select-option v-else :value="option.id">{{ $t('options.' + option.value) }}</ion-select-option>
                </div>
                <ion-select-option v-if="!required" :key="label" selected="false" value="$$$clear">{{
                    $t('options.clear')
                }}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item v-else>
            <ion-skeleton-text animated></ion-skeleton-text>
        </ion-item>
        <p v-if="error" class="error-message">{{ error }}</p>
    </div>
</template>

<script>
export default {
    name: 'OptionsSelector',
    props: ['options', 'label', 'type', 'error', 'defaultValue', 'required'],
    data() {
        return {
            currentValue: this.defaultValue,
            currentOptions: this.options
        }
    },
    methods: {
        handleChange: function(e) {
            const { value } = e.target
            this.currentValue = value
            if (value !== '$$$clear') {
                this.$emit('onChange', { value: e.target.value, type: this.type })
            } else {
                this.$refs.selector.value = ''
                this.$emit('onClear', { type: this.type })
            }
        }
    },
    watch: {
        options(options) {
            this.currentOptions = options
        },
        defaultValue(defaultValue) {
            this.currentValue = defaultValue
        }
    }
}
</script>

<style lang="scss" scoped>
.selector-label {
    color: #919191;
}

.ion-selector {
    font-weight: bold;
}
.wrapper {
    position: relative;
}
.clear {
    position: absolute;
    top: 57%;
    right: 9px;
    z-index: 2;
    .clear-button {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background-color: gray;
        color: white;
        .close {
            font-size: 200%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
}

@media (min-width: 768px) {
    ion-label {
        font-size: 110% !important;
    }
}

@media (min-width: 1200px) {
    ion-item {
        --background: transparent;
    }
}
</style>
